import * as React     from 'react';
import PropTypes      from 'prop-types';
import moment         from 'moment';
import InputContainer from './input-container';

export default class DateFieldContainer extends React.Component {
	static PRECISION_MONTH = 'month';
	static PRECISION_WEEK  = 'week';
	static PRECISION_TIME  = 'time';

	render() {
		let type           = 'date';
		let valueMoment    = moment(this.props.value);
		let formattedValue = valueMoment.format('YYYY-MM-DD');

		switch (this.props.precision) {
			case DateFieldContainer.PRECISION_MONTH: 
				type           = 'month';
				formattedValue = valueMoment.format('YYYY-MM');
				break;
			case DateFieldContainer.PRECISION_WEEK: 
				type           = 'week';
				formattedValue = valueMoment.format('YYYY-[W]WW');
				break;
			case DateFieldContainer.PRECISION_TIME: 
				type           = 'datetime-local';
				formattedValue = valueMoment.format('YYYY-MM-DD[T]HH:mm');
				break;
		};
		
		return <InputContainer {...this.props} type={type} value={this.props.value ? formattedValue : ''} />;
	}
}

DateFieldContainer.propTypes = {
	disabled    : PropTypes.bool,
	id          : PropTypes.string,
	label       : PropTypes.string,
	loading     : PropTypes.bool,
	max         : PropTypes.string,
	min         : PropTypes.string,
	name        : PropTypes.string,
	onChange    : PropTypes.func,
	placeholder : PropTypes.string,
	precision   : PropTypes.oneOf([
		DateFieldContainer.PRECISION_MONTH,
		DateFieldContainer.PRECISION_WEEK,
		DateFieldContainer.PRECISION_TIME]),
	prefixes    : PropTypes.any,
	required    : PropTypes.bool,
	suffixes    : PropTypes.any,
	step        : PropTypes.bool,
	value       : PropTypes.instanceOf(Date)
}


// WEBPACK FOOTER //
// ./src/component/form/input/datefield-container.js